import { render } from "./ReorderButtonsComponent.vue?vue&type=template&id=210175e0"
import script from "./ReorderButtonsComponent.vue?vue&type=script&lang=js"
export * from "./ReorderButtonsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__